import React from "react";
import styled from "@emotion/styled";

import { CardStyledInformationContent } from "../Card/Card";
import { CreditStatus } from "./CreditStatus";
import type { Contact, ContactCardProps, ContactType } from "./types";
import { Col, Row } from "./shared";

const ContactCardInfo = ({
  contact,
  contactType,
  className,
  customApprovedStatusText,
  customNotApprovedStatusText,
  customNotCheckedStatusText,
  onRunCreditCheck,
  onRefreshCreditCheck,
  inProgress,
}: ContactCardInfoProps) => {
  const contactName =
    contact?.customerFirstName || contact?.customerLastName
      ? `${contact?.customerFirstName ?? ""} ${contact?.customerLastName ?? ""}`
      : // Fallback to "-" if both first and last name are not available
        "-";
  const contactEmail = contact?.customerEmail?.length
    ? contact?.customerEmail
    : "-";
  const contactPhone = contact?.customerPrimaryPhone
    ? contact?.customerPrimaryPhone
    : "-";

  return (
    <ContactCardContainer className={className} data-testid="contact-card-info">
      <CardStyledInformationContent
        fields={[
          { title: "Name", value: contactName },
          { title: "Email", value: contactEmail },
          { title: "Phone", value: contactPhone },
        ]}
      />
      {contact?.creditStatus &&
        (contactType === "primary" || contactType === "secondary") && (
          <CreditStatusContainer>
            <CreditStatus
              inProgress={inProgress}
              onRefreshCreditCheck={onRefreshCreditCheck}
              onRunCreditCheck={onRunCreditCheck}
              contact={contact}
              creditStatus={contact?.creditStatus}
              customApprovedStatusText={customApprovedStatusText}
              customNotApprovedStatusText={customNotApprovedStatusText}
              customNotCheckedStatusText={customNotCheckedStatusText}
            />
          </CreditStatusContainer>
        )}
    </ContactCardContainer>
  );
};

interface ContactCardInfoProps
  extends Pick<
    ContactCardProps,
    | "customNotApprovedStatusText"
    | "customApprovedStatusText"
    | "customNotCheckedStatusText"
  > {
  contact: Contact;
  contactType: ContactType;
  className?: string;
  onRunCreditCheck?: (selectedContact: Contact) => void;
  onRefreshCreditCheck?: () => void;
  inProgress?: boolean;
}

const ContactCardContainer = styled(Col)``;

const CreditStatusContainer = styled(Row)`
  margin-top: 24px;
`;

export type { ContactCardInfoProps };
export { ContactCardInfo };
